import { render } from "./WishListUser.vue?vue&type=template&id=edf7cf96"
import script from "./WishListUser.vue?vue&type=script&lang=js"
export * from "./WishListUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pdmed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__